import { ENV } from "../constant"
import { getEnvironment } from "../services/AuthServices"

export const isBackofficeEnv = () => {
    const env = getEnvironment()
    return env === ENV.BACK_OFFICE
}